import React, { useState } from 'react';
import PdfIcon from '../Fitnessimg/icon-1.png'; // For document icons
import LegalImg from '../Fitnessimg/feature-1.jpg'; // For legal section image

const LegalInformation = () => {
  const [activeTab, setActiveTab] = useState('terms');

  return (
    <div className="container-fluid legal py-5 bg-light">
      <div className="container py-5">
        <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{ maxWidth: "800px" }}>
          <h4 className="text-primary">Legal Information</h4>
          <h1 className="display-4 mb-4">Partnership Guidelines</h1>
          <p className="mb-0">
            Transparency and clear communication are the foundation of successful collaborations. 
            Below you'll find all necessary legal documentation for potential partnerships.
          </p>
        </div>

        <div className="row g-5">
          <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.2s">
            <div className="legal-tabs">
              <ul className="nav nav-pills mb-4">
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'terms' ? 'active' : ''}`}
                    onClick={() => setActiveTab('terms')}
                  >
                    Terms & Conditions
                  </button>
                </li>
                <li className="nav-item mx-2">
                  <button 
                    className={`nav-link ${activeTab === 'contract' ? 'active' : ''}`}
                    onClick={() => setActiveTab('contract')}
                  >
                    Contract Template
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'disclosure' ? 'active' : ''}`}
                    onClick={() => setActiveTab('disclosure')}
                  >
                    Disclosure Compliance
                  </button>
                </li>
              </ul>

              <div className="tab-content p-4 bg-white rounded">
                {/* Terms & Conditions Tab */}
                <div className={`tab-pane fade ${activeTab === 'terms' ? 'show active' : ''}`}>
                  <h3 className="mb-4">Terms & Conditions</h3>
                  <div className="mb-4">
                    <h5>1. General Partnership Terms</h5>
                    <p>
                      All brand collaborations require written agreement. Content approval timelines are 
                      3-5 business days. The creator maintains creative control unless otherwise specified.
                    </p>
                  </div>
                  <div className="mb-4">
                    <h5>2. Payment Terms</h5>
                    <p>
                      50% deposit required to book collaboration dates. Balance due 3 days before posting. 
                      Late payments incur 5% monthly interest.
                    </p>
                  </div>
                  <div className="mb-4">
                    <h5>3. Content Usage</h5>
                    <p>
                      Brands may repurpose content for 6 months with proper credit. Additional usage 
                      requires separate licensing agreement.
                    </p>
                  </div>
                  <a href="/terms.pdf" download className="btn btn-primary mt-2">
                    <img src={PdfIcon} alt="PDF" className="me-2" style={{width: "20px"}} />
                    Download Full Terms
                  </a>
                </div>

                {/* Contract Template Tab */}
                <div className={`tab-pane fade ${activeTab === 'contract' ? 'show active' : ''}`}>
                  <h3 className="mb-4">Standard Contract Template</h3>
                  <div className="mb-4">
                    <p>
                      Our standard influencer agreement covers deliverables, timelines, compensation, 
                      and usage rights. This serves as a starting point for all collaborations.
                    </p>
                    <ul className="mb-4">
                      <li>Clearly defined deliverables and expectations</li>
                      <li>Payment schedule and terms</li>
                      <li>Content usage rights</li>
                      <li>Termination clauses</li>
                      <li>Confidentiality agreements</li>
                    </ul>
                    <div className="alert alert-primary">
                      <strong>Note:</strong> All contracts are customized for each collaboration based on scope.
                    </div>
                  </div>
                  <a href="/contract-template.pdf" download className="btn btn-primary">
                    <img src={PdfIcon} alt="PDF" className="me-2" style={{width: "20px"}} />
                    Download Template
                  </a>
                </div>

                {/* Disclosure Compliance Tab */}
                <div className={`tab-pane fade ${activeTab === 'disclosure' ? 'show active' : ''}`}>
                  <h3 className="mb-4">Disclosure Compliance</h3>
                  <div className="mb-4">
                    <h5>FTC Guidelines Compliance</h5>
                    <p>
                      All sponsored content includes clear disclosure following FTC guidelines. 
                      We use #ad, #sponsored, or "Paid partnership with [Brand]" as required.
                    </p>
                  </div>
                  <div className="mb-4">
                    <h5>Required Disclosures Include:</h5>
                    <ul>
                      <li>Clear and conspicuous disclosure before the "more" button</li>
                      <li>Platform-appropriate disclosure methods</li>
                      <li>Disclosures in both visuals and captions when applicable</li>
                    </ul>
                  </div>
                  <div className="mb-4">
                    <h5>Platform-Specific Requirements</h5>
                    <p>
                      We comply with all platform-specific rules including Instagram's Paid Partnership 
                      tool, YouTube's disclosure requirements, and TikTok's branded content policies.
                    </p>
                  </div>
                  <a href="/disclosure-guide.pdf" download className="btn btn-primary">
                    <img src={PdfIcon} alt="PDF" className="me-2" style={{width: "20px"}} />
                    Download Compliance Guide
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.2s">
            <div className="h-100 d-flex align-items-center">
              <div className="legal-img p-5">
                <img src={LegalImg} className="img-fluid rounded" alt="Legal Documentation" />
                <div className="legal-badge bg-primary text-white p-3 rounded mt-4">
                  <h4 className="mb-3">Need Custom Legal Documents?</h4>
                  <p className="mb-3">
                    For specialized contracts or additional legal requirements, please contact us to 
                    discuss your specific needs.
                  </p>
                  <a href="#contact" className="btn btn-light">Contact Legal Team</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Legal Resources */}
        <div className="row mt-5 wow fadeInUp" data-wow-delay="0.2s">
          <div className="col-12">
            <div className="bg-white p-5 rounded">
              <h3 className="text-primary mb-4">Additional Legal Resources</h3>
              <div className="row">
                <div className="col-md-4 mb-4">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-balance-scale text-primary me-3 mt-1 fa-2x"></i>
                    <div>
                      <h5>Intellectual Property</h5>
                      <p className="mb-0">Guidelines for content licensing and usage rights</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-4">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-gavel text-primary me-3 mt-1 fa-2x"></i>
                    <div>
                      <h5>International Campaigns</h5>
                      <p className="mb-0">Country-specific legal requirements</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-4">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-file-signature text-primary me-3 mt-1 fa-2x"></i>
                    <div>
                      <h5>Affiliate Marketing</h5>
                      <p className="mb-0">Compliance for affiliate relationships</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalInformation;